import PIdFront from './pid-front.png';
import PIdBack from './pid-back.png';
import PIdSelfie from './pid-selfie.png';
import PassportFront from './passport-front.png';
import PassportSelfie from './passport-selfie.png';

export default {
  1: { front: PIdFront, back: PIdBack, selfie: PIdSelfie },
  3: { front: PassportFront, selfie: PassportSelfie },
};

export { PIdFront, PIdBack, PIdSelfie, PassportFront, PassportSelfie };
